var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInsurance = function SvgInsurance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#insurance_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.766 79.086c13.453 7.898 26.907 15.797 40.36 23.719 9.351 5.508 25.828 21.609 37.64 13.992 17.11-11.039 23.883-47.648 20.344-66.375C111.352 9.57 67.477 2.516 35.93 15.149 24 19.905 6.985 28.484 1.594 43.578c-6.539 18.28 8.461 29.202 19.172 35.507Z",
    fill: "#EAEAE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.04 46.156v56.133h38.952l14.93-30.445L62.016 14.28 23.039 46.156Z",
    fill: "#1C7CE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.016 14.281v88.032h38.953V46.156L62.016 14.281Z",
    fill: "#014A99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.648 9.219v14.906l17.602 10.969V9.219H83.648Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.867 40.695v11.532H23.04l38.977-29.555 6.258-8.39-6.258-10.243-49.149 36.656Z",
    fill: "#014A99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.016 4.04v18.632l38.953 29.555h10.172v-11.04L62.016 4.04Z",
    fill: "#053249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.43 54.593v13.008c0 6.375 3.047 12.445 8.812 17.648 4.219 3.774 8.414 5.766 8.578 5.836l1.172.516 7.781-21.914-7.757-23.508-18.586 8.414Z",
    fill: "#99EDBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.016 46.156v45.422l1.03-.492c.165-.07 4.407-2.016 8.65-5.766 5.812-5.132 8.882-11.273 8.882-17.718V54.594l-18.562-8.438Z",
    fill: "#57C975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.82 68.305-3.117-3.117-4.078 4.078 7.172 7.172 1.195-1.195 2.203-6.633-2.203-1.524-1.172 1.22Z",
    fill: "#F7F7F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.992 61.11-6 6v8.156L72.07 65.188l-4.078-4.078Z",
    fill: "#EAEAE4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "insurance_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .5)",
    d: "M0 0h120v120H0z"
  })))));
};
export default SvgInsurance;